<template>
  <div class="awaiting-shipment-order">
    <div v-show="this.orderList.length">
      <list :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
        <ul class="main-order-list">
          <li :key="index" class="order-intro" v-for="(order, index) in orderList">
            <div class="order-title van-hairline--bottom">
              <div class="order-time">
                <span class="icon"></span>
                <span class="time">{{order.create_at}}</span>
              </div>
              <span class="order-status">待支付</span>
            </div>
            <div class="order-sku-intro">
              <sku-list :id="order.trade_id" :sku="order.sku_img"></sku-list>
            </div>
            <div class="order-info-intro">
              <div class="order-total-price">共 {{order.sku_num}} 件商品，总计：¥{{order.count_real_pay}}</div>
              <div class="order-functional-btn">
                <button class="cancel-order">取消订单</button>
                <button class="pay-now">立即支付</button>
              </div>
            </div>
          </li>
        </ul>
      </list>
    </div>

    <div class="empty" v-show="empty && !this.orderList.length">
      <no-data />
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import SkuList from '../OrderSKuList'
import NoData from './OnData'
let flag = false
export default {
  name: 'awaitingShipmentOrder',
  components: {
    SkuList,
    NoData,
    List
  },
  data () {
    return {
      orderList: [],
      empty: false,
      pageNum: 1,
      loading: false,
      finished: false
    }
  },
  created () {
    this.getOrderList()
  },
  methods: {
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getOrderList(++this.pageNum)
          .then(() => {
            this.loading = false
            flag = false
          })
      }, 1000)
    },
    async getOrderList (pageNum) {
      const res = await this.$axios.get(`api/order/list/a/${pageNum || 1}`)
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderList = data
        } else if (code === 9006) {
          if (this.pageNum === 1) {
            this.empty = true
            this.finished = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-intro {
  background-color: #fff;
  .order-title {
    padding: 0 0.2rem;
    height: 0.8rem;
    .flex-between;
    .order-time {
      height: 100%;
      display: flex;
      align-items: center;
      font-size: @fz28;
      color: #403232;
      .icon {
        width: 0.4rem;
        height: 0.4rem;
        background: url("../../assets/img/order-icon.png") center no-repeat;
        background-size: 100%;
        margin-right: 0.2rem;
      }
      .time {
      }
    }
    .order-status {
      font-size: @fz24;
    }
  }
  .order-sku-intro {
    padding: 0.2rem 0.2rem 0.37rem;
  }
  .order-info-intro {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .order-total-price {
    padding-right: 0.22rem;
    font-size: @fz28;
    color: @base;
    font-weight: bold;
    text-align: right;
  }
  .order-functional-btn {
    width: 3.7rem;
    .flex-between;
    padding: 0.4rem 0.22rem 0.34rem 0;
    button {
      width: 1.7rem;
      height: 0.68rem;
      border-radius: 30px;
      font-size: @fz24;
      color: @base;
    }
    .cancel-order {
      border: 0.5px solid #979797;
      box-sizing: border-box;
    }
    .pay-now {
      background-color: #ff3824;
      color: #fff;
    }
  }
}
</style>
